import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import Loading from '@/components/ui/loading';

const Spin: React.FC<any> = ({ children, spinning, ...rest }) => {
  return (
    <Loading isLoading={spinning} {...rest}>
      {children}
    </Loading>
  );
};

export default Spin;
